import { useQuery } from "@tanstack/react-query";
import { apiGet } from "../client";

/**
 * Hook to get job statistics
 */
export function useJobStats(
	startTime: string,
	endTime: string,
	customerIds?: string[],
	grouped?: string,
	type?: string,
	onError?: (errorCode: string) => void,
) {
	if (!customerIds) {
		return { stats: [], isLoading: false };
	}

	const { data, ...res } = useQuery<any>({
		queryKey: ["useJobStats", startTime, endTime, JSON.stringify(customerIds), grouped, type],
		queryFn: () =>
			apiGet<any>("/stats/job", {
				startTime,
				endTime,
				customerIds: customerIds ? customerIds.join(",") : "",
				grouped: grouped ? grouped : "",
				type: type ? type : "",
			}),
		onError: (error: any) => {
			const errorCode = error?.response?.data?.code || error?.message || "UNKNOWN_ERROR";
			if (onError) {
				onError(errorCode);
			}
		},
	});

	return { ...data, ...res };
}
